import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface IUpdateAssessmentSettingsVariables {
  interviewUid: string;
  isPublic: boolean;
}

interface IUpdateAssessmentSettingsResponse {
  uid: string;
  is_public: boolean;
}

const useUpdateAssessmentSettings = () => {
  const {
    mutateAsync: updateAssessmentSettings,
    data,
    isLoading,
    error,
  } = useMutation<
    IUpdateAssessmentSettingsResponse,
    Error,
    IUpdateAssessmentSettingsVariables
  >(['updateAssessmentSettings'], async ({ interviewUid, isPublic }) => {
    const body = {
      interview: interviewUid,
      is_public: isPublic,
    };

    const assessment =
      await fetchWithCsrfToken<IUpdateAssessmentSettingsResponse>(
        `${PrependUrl.ASYNC}/assessment/update_settings`,
        'POST',
        body
      );

    return assessment;
  });

  return {
    updateAssessmentSettings,
    data,
    isLoading,
    error,
  };
};

export default useUpdateAssessmentSettings;
